import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const retailerNameMapSlice = createSlice({
  name: "retailerNameMap",
  initialState: {} as Record<number, string>,
  reducers: {
    setRetailerNameMap: (_state, action: PayloadAction<Record<number, string>>) => {
      return action.payload;
    },
  },
});

export const { setRetailerNameMap } = retailerNameMapSlice.actions;
export default retailerNameMapSlice.reducer;
